const TIMEZONE = 'Asia/Baghdad';

/** Get today's date string (YYYY-MM-DD) in Baghdad timezone */
export const getBaghdadToday = (): string => {
  return new Date().toLocaleDateString('en-CA', { timeZone: TIMEZONE });
};

/** Operational day (YYYY-MM-DD) in Baghdad: it runs 04:00 -> 04:00, so before 04:00 it is still yesterday. */
export const getBaghdadOperationalDate = (now: Date = new Date()): string => {
  return new Date(now.getTime() - 4 * 3_600_000).toLocaleDateString('en-CA', { timeZone: TIMEZONE });
};

/** Format a date string to HH:MM in Baghdad timezone */
export const formatTimeBaghdad = (dateStr?: string | null): string => {
  if (!dateStr) return '--:--';
  try {
    const date = new Date(dateStr);
    return date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: TIMEZONE,
    });
  } catch {
    return '--:--';
  }
};
